import { T } from '../../styles/theme'

export default function Input({ label, style, ...props }) {
  return (
    <div style={{ marginBottom: 12 }}>
      {label && <div style={{ fontSize: 13, color: T.muted, marginBottom: 6 }}>{label}</div>}
      <input
        style={{
          width: '100%', background: T.bg, border: `1px solid ${T.cardB}`, borderRadius: 12,
          padding: '12px 16px', color: T.text, fontSize: 15, fontFamily: 'DM Sans, sans-serif',
          outline: 'none', ...style,
        }}
        {...props}
      />
    </div>
  )
}
